import React from "react";
import {useNavigate} from "react-router-dom";
import Modal from "../modal/modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

export default function LimitExceededModal({show, setter, error, current, max, type, code, subscriptionStatus}) {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const getTitle = () => {
        if (code === 'NO_SUBSCRIPTION') {
            return 'No Active Subscription';
        }
        if (code === 'SUBSCRIPTION_NOT_ACTIVE') {
            if (subscriptionStatus === 'pending') {
                return 'Subscription Pending';
            } else if (subscriptionStatus === 'suspended') {
                return 'Subscription Suspended';
            } else if (subscriptionStatus === 'cancelled') {
                return 'Subscription Cancelled';
            }
            return 'Subscription Not Active';
        }

        switch(type) {
            case 'companies':
                return 'Company Limit Reached';
            case 'devices':
                return 'Device Limit Reached';
            case 'users':
                return 'User Limit Reached';
            default:
                return 'Limit Reached';
        }
    };

    const getMessage = () => {
        if (code === 'SUBSCRIPTION_NOT_ACTIVE') {
            if (subscriptionStatus === 'pending') {
                return 'Your subscription request is being reviewed by the administrator. You will be notified once it is approved.';
            } else if (subscriptionStatus === 'suspended') {
                return 'Your subscription has been suspended. Contact the administrator for more information.';
            } else if (subscriptionStatus === 'cancelled') {
                return 'Your subscription has been cancelled. Activate a new plan to continue.';
            }
            return 'Your subscription is not active. You need an active plan to use this feature.';
        }

        if (code === 'NO_SUBSCRIPTION') {
            return 'You don\'t have an active subscription. Select a plan to start using all features.';
        }

        switch(type) {
            case 'companies':
                return `Your current plan allows a maximum of ${max} ${max !== 1 ? 'companies' : 'company'}. You currently have ${current}.`;
            case 'devices':
                return `Your current plan allows a maximum of ${max} ${max !== 1 ? 'devices' : 'device'}. You currently have ${current}.`;
            case 'users':
                return `Your current plan allows a maximum of ${max} ${max !== 1 ? 'users' : 'user'}. You currently have ${current}.`;
            default:
                return error || 'You have reached the limit of your current plan.';
        }
    };

    const getButtonText = () => {
        if (code === 'SUBSCRIPTION_NOT_ACTIVE' && subscriptionStatus === 'pending') {
            return t('limitExceeded.upgrade');
        }
        return t('limitExceeded.upgrade');
    };

    const handleUpgrade = () => {
        setter(false);
        if (code === 'SUBSCRIPTION_NOT_ACTIVE' && subscriptionStatus === 'pending') {
            navigate('/settings/payments');
        } else {
            navigate('/pricing');
        }
    };

    return (
        <Modal
            show={show}
            setter={setter}
            name={getTitle()}
            buttonName={getButtonText()}
            onClick={handleUpgrade}
        >
            <div style={{textAlign: 'center', padding: '20px 0'}}>
                <div style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '50%',
                    background: '#FEF3C7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '28px',
                    color: '#F59E0B'
                }}>
                    <FontAwesomeIcon icon={faExclamationTriangle}/>
                </div>

                <p style={{fontSize: '16px', color: '#1E293B', marginBottom: '12px'}}>
                    {getMessage()}
                </p>

                <p style={{fontSize: '14px', color: '#64748B', lineHeight: '1.6'}}>
                    To add more {type === 'companies' ? 'companies' : type === 'devices' ? 'devices' : 'users'},
                    you need to upgrade your plan to one with greater capacity.
                </p>

                <div style={{
                    backgroundColor: '#F0FDF4',
                    border: '1px solid #BBF7D0',
                    borderRadius: '8px',
                    padding: '12px',
                    marginTop: '16px'
                }}>
                    <p style={{fontSize: '13px', color: '#166534', margin: 0}}>
                        Upgrade your plan to unlock more features and capacity.
                    </p>
                </div>
            </div>
        </Modal>
    );
}
